import RegionalCommonUtils from "@/core/utils/regional/RegionalCommonUtils";

class PlUtils {

  static validateLEI = RegionalCommonUtils.validateLEI;
}

export default PlUtils;
